<template>
  <!-- Prolific participants: identity comes from URL — never show login -->
  <prolific-entry v-if="isProlific"></prolific-entry>
  <login v-else></login>
</template>

<script>
import Login from '../components/Login'
import ProlificEntry from '../components/ProlificEntry'
import { hasProlificParams } from '@/utils/prolific'

export default {
  name: 'Home',
  components: { Login, ProlificEntry },
  computed: {
    isProlific() {
      // Also reads window.location.search (Prolific puts IDs there)
      return hasProlificParams(this.$route.query)
    },
  },
}
</script>
